<template>
  <div class="xc-page xc-page-sandwich">
    <div class="xc-page-main">
      <div class="xc-breadcrumb">
        <a href="">系统设置</a>
        <a href="">部门管理</a>
      </div>
      <div class="xc-row xc-s-flex">
        <div class="xc-card">
          <div class="xc-card-content">
            <form class="xc-form" name="search" style="margin-bottom:0px">
              <div class="xc-form-inline">
                <ol class="search-line">
                    <li class="search-list">
                        <span>部门名称：</span>
                        <input type="text" placeholder="请输入部门名称" class="xc-input" v-model="mix_query.departmentName">
                    </li>
                    <li class="search-list">
                        <span>状态：</span>
                        <select class="xc-select" name="status" v-model="mix_query.status">
                            <option value="">不限</option>
                            <option value="1">启用</option>
                            <option value="0">禁用</option>
                        </select>
                    </li>
                    <li class="xc-btn-group" style="float:left">
                        <button class="xc-btn xc-btn-primary" type="submit" @click.prevent="mix_search">查询</button>
                        <button class="xc-btn xc-btn-default" type="button" @click="add">添加</button>
                    </li>
                    <li class="null-box"></li>
                </ol>
              </div>
            </form>
            <table class="xc-table">
              <thead>
                <tr>
                  <th>编号</th>
                  <th>部门名称</th>
                  <th>上级部门</th>
                  <th>电话</th>
                  <th>传真</th>
                  <th>状态</th>
                  <th>操作人</th>
                  <th>最后操作时间</th>
                  <th>
                    操作
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="list && list.length">
                  <tr v-for="(item, index) in list" :key="index">
                    <td>{{ item.departmentId }}</td>
                    <td>{{ item.departmentName }}</td>
                    <td>{{ item.parentDepartmentName }}</td>
                    <td>{{ item.phoneNumber }}</td>
                    <td>{{ item.fax }}</td>
                    <td>{{ getStatus(item.status) }}</td>
                    <td>{{ item.operator }}</td>
                    <td>{{ item.updateTime }}</td>
                    <td>
                      <xc-btn-select title="管理">
                        <template v-if="groups.length">
                          <xc-btn-select-item
                            v-for="(obj, key) in groups(item)"
                            :key="key"
                            :title="obj.name"
                            @click.native="mix_action(obj.id, item, $event)"
                          ></xc-btn-select-item>
                        </template>
                      </xc-btn-select>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="20" class="xc-s-tac">暂无数据</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="xc-page-footer">
      <!-- 分页 -->
      <xc-pagination
        @change="mix_pageChange"
        :page="mix_page"
        :total="mix_total"
        :size="mix_pageSize"
      />
    </div>

    <!--弹窗-->
    <div class="xc-card">
      <!-- 添加 -->
      <div class="xc-modal xc-modal-dialog" v-if="modalName == 'add'">
        <!-- 遮罩层 -->
        <div class="xc-modal-mask" @click="modalName = null"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">添加</div>
              <div class="xc-modal-close" @click="modalName = null"></div>
            </div>
            <div class="xc-modal-body">
              <form class="xc-form" name="add" data-vv-scope="add">
                <div class="xc-form-inline">
                  <xc-form-item
                    label="部门名称"
                    required
                    :error="errors.first('departmentName', 'add')"
                  >
                    <input
                      type="text"
                      placeholder="请输入部门名称"
                      name="departmentName"
                      class="xc-input"
                      v-validate="'required'"
                      data-vv-as="部门名称"
                      :class="{
                        'xc-input-error': errors.first('departmentName', 'add')
                      }"
                    />
                  </xc-form-item>
                  <!--<xc-form-item label="部门编码" required :error="errors.first('departmentCode','add')">
                    <input
                      type="text"
                      placeholder="请输入部门编码"
                      name="departmentCode"
                      v-validate="'required'"
                      data-vv-as="部门编码"
                      class="xc-input"
                    >
                  </xc-form-item>-->
                  <xc-form-item label="电话">
                    <input
                      type="tel"
                      maxlength="11"
                      placeholder="请输入电话"
                      name="phoneNumber"
                      class="xc-input"
                    />
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item label="传真">
                    <input
                      type="text"
                      placeholder="请输入传真"
                      name="fax"
                      class="xc-input"
                    />
                  </xc-form-item>
                  <xc-form-item label="上级部门">
                    <div class="department">
                      <input
                        type="hidden"
                        name="parentId"
                        :value="departmentId"
                        class="parentId"
                      />
                      <input
                        type="text"
                        name="parentName"
                        :value="departmentName"
                        class="parentName xc-input xc-input-disabled"
                        disabled
                        placeholder="请选择上级部门"
                      />
                      <span
                        class="myDepartment"
                        @click="selectDepartment('add')"
                        ><i class="fa fa-align-center"></i>
                      </span>
                    </div>
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item
                    label="是否启用"
                    required
                    :error="errors.first('status', 'add')"
                  >
                    <label class="xc-checkbox-wrap">
                      <input
                        type="radio"
                        name="status"
                        class="xc-radio"
                        value="1"
                        :checked="true"
                        v-validate="'required'"
                        data-vv-as="状态"
                      />
                      <span class="xc-checkbox-label">启用</span>
                    </label>
                    <label class="xc-checkbox-wrap">
                      <input
                        type="radio"
                        name="status"
                        class="xc-radio"
                        value="0"
                        v-validate="'required'"
                        data-vv-as="状态"
                      />
                      <span class="xc-checkbox-label">禁用</span>
                    </label>
                  </xc-form-item>
                </div>
              </form>
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button class="xc-btn xc-btn-default" @click="modalName = null">
                  取消
                </button>
                <button class="xc-btn xc-btn-primary" @click="addSubmit">
                  确定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--编辑弹窗-->
      <div class="xc-modal xc-modal-dialog" v-if="modalName == 'edit'">
        <div class="xc-modal-mask" @click="modalName = null"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">编辑</div>
              <div class="xc-modal-close" @click="modalName = null"></div>
            </div>
            <div class="xc-modal-body">
              <form class="xc-form" name="edit" data-vv-scope="edit">
                <div class="xc-form-inline">
                  <xc-form-item
                    label="部门名称:"
                    required
                    :error="errors.first('departmentName', 'edit')"
                  >
                    <input
                      type="text"
                      v-validate="'required'"
                      data-vv-as="部门名称"
                      placeholder="请输入部门名称"
                      class="xc-input"
                      name="departmentName"
                      v-model="current.departmentName"
                      :class="{
                        'xc-input-error': errors.first('departmentName', 'edit')
                      }"
                    />
                    <input
                      type="hidden"
                      name="departmentId"
                      v-model="current.departmentId"
                    />
                  </xc-form-item>
                  <!--  <xc-form-item label="部门编码" required :error="errors.first('departmentCode','edit')">
                        <input
                            type="text"
                            placeholder="请输入部门编码"
                            name="departmentCode"
                            v-validate="'required'"
                            data-vv-as="部门编码"
                            class="xc-input"
                            v-model="current.departmentCode"
                        >
                    </xc-form-item>-->
                  <xc-form-item label="电话:">
                    <input
                      type="tel"
                      name="phoneNumber"
                      maxlength="11"
                      class="xc-input"
                      placeholder="请输入电话号码"
                      v-model="current.phoneNumber"
                    />
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item label="传真:">
                    <input
                      type="text"
                      name="fax"
                      class="xc-input"
                      placeholder="请输入传真"
                      v-model="current.fax"
                    />
                  </xc-form-item>
                  <xc-form-item label="上级部门">
                    <div class="department">
                      <input
                        type="hidden"
                        name="parentId"
                        class="parentId"
                        :value="departmentId"
                      />
                      <input
                        type="text"
                        name="parentName"
                        :value="departmentName"
                        class="parentName xc-input"
                        disabled
                        placeholder="请选择上级部门"
                      />
                      <span
                        class="myDepartment"
                        @click="selectDepartment('edit')"
                        ><i class="fa fa-align-center"></i>
                      </span>
                    </div>
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item
                    label="是否启用"
                    required
                    :error="errors.first('status', 'edit')"
                  >
                    <label class="xc-checkbox-wrap">
                      <input
                        type="radio"
                        name="status"
                        class="xc-radio"
                        value="1"
                        v-model="current.status"
                        v-validate="'required'"
                        data-vv-as="状态"
                      />
                      <span class="xc-checkbox-label">启用</span>
                    </label>
                    <label class="xc-checkbox-wrap">
                      <input
                        type="radio"
                        name="status"
                        class="xc-radio"
                        value="0"
                        v-model="current.status"
                        v-validate="'required'"
                        data-vv-as="状态"
                      />
                      <span class="xc-checkbox-label">禁用</span>
                    </label>
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item label="创建时间:">
                    <input
                      type="text"
                      disabled
                      name="createdTime"
                      class="xc-input xc-input-disabled"
                      placeholder=""
                      v-model="current.addTime"
                    />
                  </xc-form-item>
                  <xc-form-item label="最后修改时间:">
                    <input
                      type="text"
                      disabled
                      name="lastTime"
                      class="xc-input xc-input-disabled"
                      placeholder=""
                      v-model="current.updateTime"
                    />
                  </xc-form-item>
                </div>
                <div class="xc-form-inline">
                  <xc-form-item label="操作人:">
                    <input
                      type="text"
                      name="operator"
                      disabled
                      class="xc-input xc-input-disabled"
                      placeholder=""
                      v-model="current.operator"
                    />
                  </xc-form-item>
                </div>
              </form>
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button class="xc-btn xc-btn-default" @click="modalName = null">
                  取消
                </button>
                <button class="xc-btn xc-btn-primary" @click="editSubmit">
                  确定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--启用弹窗-->
      <div class="xc-modal xc-modal-dialog" v-if="modalName == 'enable'">
        <div class="xc-modal-mask" @click="modalName = null"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">启用</div>
              <div class="xc-modal-close" @click="modalName = null"></div>
            </div>
            <div class="xc-modal-body xc-flex-center">
              确定启用该部门?
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button class="xc-btn xc-btn-default" @click="modalName = null">
                  取消
                </button>
                <button class="xc-btn xc-btn-primary" @click="enableSubmit">
                  确定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--禁用弹窗-->
      <div class="xc-modal xc-modal-dialog" v-if="modalName == 'disabled'">
        <div class="xc-modal-mask" @click="modalName = null"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">禁用</div>
              <div class="xc-modal-close" @click="modalName = null"></div>
            </div>
            <div class="xc-modal-body xc-flex-center">
              确定禁用该部门?禁用后该部门下所有用户账号不能使用
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button class="xc-btn xc-btn-default" @click="modalName = null">
                  取消
                </button>
                <button class="xc-btn xc-btn-primary" @click="disabledSubmit">
                  确定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--删除-->
      <div class="xc-modal xc-modal-dialog" v-if="modalName == 'delete'">
        <div class="xc-modal-mask" @click="modalName = null"></div>
        <div class="xc-modal-wrap xc-anim-scaleIn">
          <div class="xc-modal-content">
            <div class="xc-modal-header">
              <div class="xc-modal-title">删除</div>
              <div class="xc-modal-close" @click="modalName = null"></div>
            </div>
            <div class="xc-modal-body xc-flex-center">
              确定删除该部门?
            </div>
            <div class="xc-modal-footer xc-flex-center">
              <div class="xc-btn-group">
                <button class="xc-btn xc-btn-default" @click="modalName = null">
                  取消
                </button>
                <button class="xc-btn xc-btn-primary" @click="deleteSubmit">
                  确定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listMixin from "../xc-ui/mixins/list";
import "@/utils/form-format";
import "@/libs/vee-validate";
import dateFormat from "@/utils/date-format";
import { getList, save, update, changeStatus, remove } from "@/api/department";
import "@/libs/font-awesome";
import myLayerImport from "@/libs/myLayer";
myLayerImport();

export default {
  name: "departmentList",

  mixins: [listMixin],
  data() {
    return {
      adminPath: this.$config.adminPath,
      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "departmentId",

      list: [],

      // 默认查询参数
      mix_query: {
        departmentName: "",
        status: ""
      },
      group: [
        {
          name: "编辑",
          id: 0
        },
        /*{
                name:"管理门店",
                id:1
            },*/
        {
          name: "启用",
          id: 2
        },
        {
          name: "禁用",
          id: 3
        },
        {
          name: "删除",
          id: 4
        }
      ],
      modalName: null, //弹窗名称,add表示添加\edit表示编辑
      current: null, //当前表行
      departmentName: "",
      departmentId: ""
    };
  },
  methods: {
    //判断分组内容
    groups: function(item) {
      var arr = this.group.slice(0);
      if (item.status == 0) {
        //0表示禁用,1表示启用
        arr.splice(2, 1);
      } else {
        arr.splice(1, 1);
      }
      return arr;
    },
    //添加分组
    add() {
      this.modalName = "add";
      this.departmentName = "";
      this.departmentId = "";
    },
    //选择部门
    selectDepartment: function(type) {
      var currentId = "";
      if (type == "edit") {
        currentId = this.current.departmentId;
      }
      var _this = this;
      myLayer.open({
        type: 2,
        title: false,
        closeBtn: 0,
        content:
          this.adminPath + "/system/department/select?currentId=" + currentId,
        success: function(layero, index) {
          //    声明一个全局函数
          window.init = function(name, id) {
            _this.departmentName = name;
            _this.departmentId = id;
          };
        }
      });
    },
    // 初始化数据
    initData() {
      var _this = this;
      // 默认搜索的数据
      const search = {
        pageNum: this.mix_page,
        pageSize: this.mix_pageSize,
        ...this.mix_query
      };

      getList(search)
        .then(function(res) {
          //添加mix_checkbox属性
          _this.list = _this.mix_format(res.data.list);
          _this.mix_total = res.data.total;
          _this.mix_page = res.data.pageNum;
          _this.mix_pageSize = res.data.pageSize;
        })
        .catch(function(result) {
          _this.$message.error("出了一点问题");
        });
    },
    // 操作单条数据
    action(...args) {
      const [action, item, index] = args;
      const e = args[args.length - 1];
      this.current = { ...item };
      switch (action) {
        case 0:
          this.modalName = "edit";
          this.departmentName = this.current.parentDepartmentName;
          this.departmentId = "";
          break;
        case 1:
          //管理门店
          this.$router.push(
            this.adminPath +
              "/system/store?departmentId=" +
              this.current.departmentId
          );
          break;
        case 2:
          this.modalName = "enable";
          break;
        case 3:
          this.modalName = "disabled";
          break;
        case 4:
          this.modalName = "delete";
          break;
        default:
          break;
      }
    },
    //    添加确定
    addSubmit: function() {
      var _this = this;
      var add = document.add;
      // 验证器命名空间
      const scope = "add";

      this.$validator
        .validateAll(scope)
        .then(validate => {
          if (validate) {
            return this.$formFormat(add);
          } else {
            let error = this.errors.items[0].msg;
            // this.$message.error(error)
            return false;
          }
        })
        .then(formData => {
          if (formData) {
            //    发送请求
            save(formData)
              .then(function(res) {
                _this.$message.success(res.msg);
                _this.modalName = null;
                _this.initData();
              })
              .catch(function(result) {
                console.log(result);
              });
          }
        });
    },
    //    编辑确定
    editSubmit: function() {
      var _this = this;
      var myForm = document.edit;
      // 验证器命名空间
      const scope = "edit";

      this.$validator
        .validateAll(scope)
        .then(validate => {
          if (validate) {
            return this.$formFormat(myForm);
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then(formData => {
          if (formData) {
            update(formData)
              .then(function(res) {
                _this.$message.success(res.msg);
                _this.modalName = null;
                _this.initData();
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        });
    },
    //  启用确定
    enableSubmit: function() {
      var _this = this;
      this.current.status = 1;
      changeStatus(this.current).then(function(success) {
        _this.$message.success("启用成功");
        _this.modalName = null;
        _this.initData();
      });
    },
    //    禁用确定
    disabledSubmit: function() {
      var _this = this;
      this.current.status = 0;
      changeStatus(this.current).then(function(success) {
        _this.$message.success("禁用成功");
        _this.modalName = null;
        _this.initData();
      });
    },
    //    删除确定
    deleteSubmit: function() {
      var obj = {
        departmentId: this.current.departmentId
      };
      remove(obj).then(v => {
        this.$message.success(v.msg);
        this.modalName = null;
        this.initData();
      });
    },
    //    过滤状态
    getStatus: function(status) {
      if (status == 1) {
        return "启用";
      }
      return "禁用";
    }
  }
};
</script>

<style scoped lang="scss">

.department {
  position: relative;
  .myDepartment {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    box-shadow: -1px 0 2px 0 #bbb;
    width: 32px;
    line-height: 32px;
    text-align: center;
  }
}

.search-line {
    list-style-type: none;
}

.search-list {
    float: left;
    margin: 0px 25px 25px 0px;
}

.null-box {
    clear: both;
}

</style>
